import { atom, useAtomValue, useSetAtom } from 'jotai'
import { useCallback } from 'react'

/**
 * Ids this window minted for new chats that the backend hasn't confirmed. The
 * submit flow renames a temp id at `metadata`, but a turn that fails before
 * then leaves the view on an id the API has never heard of, so anything that
 * fetches by chat id checks here first.
 */
const localChatIdsAtom = atom<ReadonlySet<string>>(new Set<string>())

export const useLocalChatIds = (): ReadonlySet<string> => useAtomValue(localChatIdsAtom)

export const useTrackLocalChatId = () => {
  const setLocalChatIds = useSetAtom(localChatIdsAtom)
  return useCallback(
    (chatId: string) => setLocalChatIds((prev) => (prev.has(chatId) ? prev : new Set(prev).add(chatId))),
    [setLocalChatIds],
  )
}

/** The backend named this id in a `metadata` event, so it is a real conversation now. */
export const useConfirmServerChatId = () => {
  const setLocalChatIds = useSetAtom(localChatIdsAtom)
  return useCallback(
    (chatId: string) =>
      setLocalChatIds((prev) => {
        if (!prev.has(chatId)) {
          return prev
        }
        const next = new Set(prev)
        next.delete(chatId)
        return next
      }),
    [setLocalChatIds],
  )
}
